export const profile = {
  headShot: {
    url: `boren_headShot.jpg`,
    alt: `我的頭貼`,
  },
  autobiography: `半路轉職的軟體工程師，喜歡研究新技術，追求不斷精進的clean code，享受發現問題的成就感。`,
  experience: [
    {
      id: "3",
      name: `後端工程師`,
      company: `樺宥智慧科技`,
    },
    {
      id: "2",
      name: `前端工程師`,
      company: `嘉仕合科技`,
    },
    {
      id: "1",
      name: `前端工程師養成班`,
      company: `中壢資策會`,
    }
 
    
  ],
  project: [
    {
      id: "4",
      name: `先鋒機械生產管理系統`,
      image: {
        filename: `pioneer_smartfa.png`,
        alt: `alt`,
      },link: `https://www.pioneerm.com/tw/industry-4.0.html`,
    },  
    {
      id: "2",
      name: `新北市Ivoting投票系統`,
      image: {
        filename: `new_taipei_ivoting.png`,
        alt: `alt`,
      },  link: `https://www.vote.ntpc.gov.tw/`,
    }, 
      {
      id: "1",
      name: `Chocoline 團體專體`,
      image: {
        filename: `chocoline_preview1.png`,
        alt: `alt`,
      } 
    },
    {
      id: "3",
      name: `Boren觀點 Blog`,
      image: {
        filename: `boren_point_view.png`,
        alt: `alt`,
      },
      link: `https://boren-viewpoint.netlify.app/`,
    },
 
    // {
    //   id: "3",
    //   name: `錠嵂保險經紀人官網`,
    // },
  ],
}
